import $foreign from "./foreign.cjs";
var unsafeDecodeURI = $foreign.unsafeDecodeURI;
var unsafeDecodeURIComponent = $foreign.unsafeDecodeURIComponent;
var unsafeEncodeURI = $foreign.unsafeEncodeURI;
var unsafeEncodeURIComponent = $foreign.unsafeEncodeURIComponent;
var unsafeStringify = $foreign.unsafeStringify;
var unsafeToExponential = $foreign.unsafeToExponential;
var unsafeToFixed = $foreign.unsafeToFixed;
var unsafeToPrecision = $foreign.unsafeToPrecision;
export { unsafeDecodeURI, unsafeDecodeURIComponent, unsafeEncodeURI, unsafeEncodeURIComponent, unsafeStringify, unsafeToExponential, unsafeToFixed, unsafeToPrecision };
